module.exports = __webpack_public_path__ + "static/media/padlock.1d7cd458.svg";